// Iconic Collectors Theme JS

(function () {
  'use strict';

  // ===== MOBILE NAVIGATION =====
  const menuBtn = document.getElementById('mobile-menu-btn');
  const overlay = document.getElementById('mobile-overlay');
  const drawer = document.getElementById('mobile-drawer');
  const closeBtn = document.getElementById('mobile-close');

  function openMenu() {
    overlay.style.display = 'block';
    setTimeout(() => {
      overlay.classList.add('open');
      drawer.classList.add('open');
    }, 10);
    document.body.style.overflow = 'hidden';
    menuBtn && menuBtn.setAttribute('aria-expanded', 'true');
  }

  function closeMenu() {
    overlay.classList.remove('open');
    drawer.classList.remove('open');
    document.body.style.overflow = '';
    menuBtn && menuBtn.setAttribute('aria-expanded', 'false');
    setTimeout(() => { overlay.style.display = 'none'; }, 300);
  }

  if (menuBtn) menuBtn.addEventListener('click', openMenu);
  if (overlay) overlay.addEventListener('click', closeMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenu();
  });

  // Active nav link
  document.querySelectorAll('.header-nav a, .nav-dropdown-menu a').forEach(function (link) {
    try {
      if (new URL(link.href).pathname === window.location.pathname) {
        link.classList.add('active');
      }
    } catch (e) {}
  });

  // Mobile accordion dropdowns
  document.querySelectorAll('.mobile-nav-accordion-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var sub = this.nextElementSibling;
      var isOpen = sub.classList.contains('open');
      document.querySelectorAll('.mobile-nav-sub').forEach(function (s) { s.classList.remove('open'); });
      document.querySelectorAll('.mobile-nav-accordion-btn').forEach(function (b) {
        b.classList.remove('open');
        b.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        sub.classList.add('open');
        this.classList.add('open');
        this.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // ===== SEARCH BAR CATEGORY FILTER =====
  var searchForm = document.querySelector('.search-bar-form');
  var categorySelect = document.getElementById('search-category');
  if (searchForm && categorySelect) {
    searchForm.addEventListener('submit', function (e) {
      var cat = categorySelect.value;
      if (cat) {
        e.preventDefault();
        var q = searchForm.querySelector('input[name="q"]').value;
        window.location.href = '/collections/' + cat + (q ? '?q=' + encodeURIComponent(q) : '');
      }
    });
  }

  // Language switching handled by Shopify localization forms (locale_code POST)

  // ===== OVERLAY SELECT: sync visible value span when selection changes =====
  function syncSelectVal(sel) {
    var wrap = sel.closest('.currency-select-wrap');
    if (!wrap) return;
    var span = wrap.querySelector('.select-val');
    if (span && sel.options[sel.selectedIndex]) {
      span.textContent = sel.options[sel.selectedIndex].text;
    }
  }

  document.querySelectorAll('.select-overlay').forEach(function (sel) {
    syncSelectVal(sel);
    sel.addEventListener('change', function () { syncSelectVal(this); });
  });

  // ===== HERO CAROUSEL =====
  (function initCarousel() {
    var carousel = document.querySelector('.hero-carousel');
    if (!carousel) return;

    var slidesWrap = carousel.querySelector('.hero-slides');
    var slides = carousel.querySelectorAll('.hero-slide');
    var dots = carousel.querySelectorAll('.hero-dot');
    var prevBtn = carousel.querySelector('.hero-prev');
    var nextBtn = carousel.querySelector('.hero-next');
    var autoplayMs = parseInt(carousel.dataset.autoplay || '5000', 10);
    var total = slides.length;
    var current = 0;
    var timer = null;

    function goTo(idx) {
      current = ((idx % total) + total) % total;
      slidesWrap.style.transform = 'translateX(-' + (current * 100) + '%)';
      dots.forEach(function (d, i) {
        d.classList.toggle('hero-dot--active', i === current);
        d.setAttribute('aria-selected', i === current ? 'true' : 'false');
      });
    }

    function startAutoplay() {
      clearInterval(timer);
      timer = setInterval(function () { goTo(current + 1); }, autoplayMs);
    }

    function stopAutoplay() { clearInterval(timer); }

    if (prevBtn) prevBtn.addEventListener('click', function () { stopAutoplay(); goTo(current - 1); startAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { stopAutoplay(); goTo(current + 1); startAutoplay(); });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { stopAutoplay(); goTo(i); startAutoplay(); });
    });

    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);

    goTo(0);
    startAutoplay();
  })();

  // ===== WISHLIST =====
  // Stores [{id, title, url, price, image}] — no API calls needed
  (function() {
    var WISHLIST_KEY = 'ic_wishlist';

    function getWishlist() {
      try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); } catch(e) { return []; }
    }

    function saveWishlist(list) {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    }

    function isInWishlist(id) {
      return getWishlist().some(function(item) { return String(item.id) === String(id); });
    }

    function updateBtnState(btn, isActive) {
      btn.classList.toggle('active', isActive);
      var filled = btn.querySelector('.heart-filled');
      var outline = btn.querySelector('.heart-outline');
      if (filled) filled.style.display = isActive ? '' : 'none';
      if (outline) outline.style.opacity = isActive ? '0' : '1';
      btn.setAttribute('aria-label', isActive ? 'Remove from wishlist' : 'Add to wishlist');
      var label = btn.querySelector('.wishlist-page-label');
      if (label) label.textContent = isActive ? 'Remove from Wishlist' : 'Add to Wishlist';
    }

    function updateWishlistCount() {
      var count = getWishlist().length;
      document.querySelectorAll('#wishlist-count, .wishlist-count-badge').forEach(function(badge) {
        badge.textContent = count;
        badge.style.display = count > 0 ? 'flex' : 'none';
      });
    }

    function initButtons() {
      document.querySelectorAll('.product-wishlist, .product-wishlist-page-btn').forEach(function(btn) {
        var id = btn.dataset.productId;
        if (!id) return;
        updateBtnState(btn, isInWishlist(id));

        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var list = getWishlist();
          var existing = list.findIndex(function(item) { return String(item.id) === String(id); });
          var adding = existing === -1;
          if (adding) {
            list.push({
              id: id,
              title: btn.dataset.productTitle || '',
              url: btn.dataset.productUrl || '',
              price: parseInt(btn.dataset.productPrice, 10) || 0,
              image: btn.dataset.productImage || ''
            });
          } else {
            list.splice(existing, 1);
          }
          saveWishlist(list);
          updateBtnState(btn, adding);
          updateWishlistCount();
          btn.classList.add('wishlist-pulse');
          setTimeout(function() { btn.classList.remove('wishlist-pulse'); }, 300);
        });
      });
    }

    // Wishlist drawer open/close
    var drawer = document.getElementById('wishlist-drawer');
    var drawerOverlay = document.getElementById('wishlist-overlay');
    var drawerClose = document.getElementById('wishlist-drawer-close');
    var wishlistToggle = document.getElementById('wishlist-toggle');

    function openWishlistDrawer() {
      renderWishlistDrawer();
      if (drawer) drawer.classList.add('open');
      if (drawerOverlay) { drawerOverlay.style.display = 'block'; setTimeout(function() { drawerOverlay.classList.add('open'); }, 10); }
      document.body.style.overflow = 'hidden';
    }

    function closeWishlistDrawer() {
      if (drawer) drawer.classList.remove('open');
      if (drawerOverlay) { drawerOverlay.classList.remove('open'); setTimeout(function() { drawerOverlay.style.display = 'none'; }, 300); }
      document.body.style.overflow = '';
    }

    function formatWishlistPrice(cents) {
      if (!cents) return '';
      var currency = localStorage.getItem('ic_currency') || 'USD';
      // Use CurrencyConverter if rates loaded (it's defined later in this closure, available at call time)
      if (typeof CurrencyConverter !== 'undefined' && CurrencyConverter.rates) {
        var formatted = CurrencyConverter.format(cents, currency);
        if (formatted) return formatted;
      }
      // Fallback: show raw cents with basic symbol
      var symbols = { AED:'AED ', USD:'$', EUR:'€', GBP:'£', HUF:'HUF ', SAR:'SAR ', QAR:'QAR ', KWD:'KWD ', BHD:'BHD ', EGP:'EGP ', TRY:'₺', INR:'₹', JPY:'¥', CAD:'CA$', AUD:'A$', CHF:'CHF ' };
      var sym = symbols[currency] || (currency + ' ');
      return sym + (cents / 100).toLocaleString(undefined, {minimumFractionDigits:2, maximumFractionDigits:2});
    }

    function renderWishlistDrawer() {
      var list = getWishlist();
      var content = document.getElementById('wishlist-drawer-content');
      if (!content) return;
      if (list.length === 0) {
        content.innerHTML = '<div class="wishlist-empty"><svg width="48" height="48" viewBox="0 0 24 24" fill="none" style="margin:0 auto 16px;display:block;color:#ccc"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg><p>Your wishlist is empty.</p><a href="/collections/all" class="btn-primary" style="display:inline-flex;margin-top:16px;">Browse Collection</a></div>';
        return;
      }
      content.innerHTML = list.map(function(p) {
        var imgTag = p.image
          ? '<img src="' + p.image + '" alt="' + p.title + '" width="72" height="72" loading="lazy">'
          : '<div style="width:72px;height:72px;background:var(--off-white);border-radius:var(--radius);"></div>';
        var priceStr = formatWishlistPrice(p.price);
        return '<div class="wishlist-drawer-item" data-id="' + p.id + '">' +
          '<a href="' + p.url + '" class="wishlist-item-img">' + imgTag + '</a>' +
          '<div class="wishlist-item-info">' +
            '<a href="' + p.url + '" class="wishlist-item-title">' + p.title + '</a>' +
            (priceStr ? '<div class="wishlist-item-price">' + priceStr + '</div>' : '') +
          '</div>' +
          '<button class="wishlist-item-remove" data-id="' + p.id + '" aria-label="Remove from wishlist">✕</button>' +
        '</div>';
      }).join('');

      content.querySelectorAll('.wishlist-item-remove').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var rid = this.dataset.id;
          var l = getWishlist();
          var i = l.findIndex(function(item) { return String(item.id) === String(rid); });
          if (i > -1) l.splice(i, 1);
          saveWishlist(l);
          updateWishlistCount();
          this.closest('.wishlist-drawer-item').remove();
          var heartBtn = document.querySelector('.product-wishlist[data-product-id="' + rid + '"], .product-wishlist-page-btn[data-product-id="' + rid + '"]');
          if (heartBtn) updateBtnState(heartBtn, false);
          if (l.length === 0) renderWishlistDrawer();
        });
      });
    }

    if (wishlistToggle) wishlistToggle.addEventListener('click', openWishlistDrawer);
    if (drawerClose) drawerClose.addEventListener('click', closeWishlistDrawer);
    if (drawerOverlay) drawerOverlay.addEventListener('click', closeWishlistDrawer);

    initButtons();
    updateWishlistCount();
  })();

  // ===== CURRENCY CONVERTER =====
  const CurrencyConverter = {
    CACHE_KEY: 'ic_rates_v2',
    PREF_KEY: 'ic_currency',
    CACHE_TTL: 3600000,
    BASE: (document.documentElement.dataset.shopCurrency || 'HUF').toUpperCase(),
    rates: null,

    symbols: {
      AED: 'AED ', USD: '$', EUR: '€', GBP: '£', HUF: 'HUF ',
      SAR: 'SAR ', QAR: 'QAR ', KWD: 'KWD ', BHD: 'BHD ',
      EGP: 'EGP ', TRY: '₺', INR: '₹', JPY: '¥',
      CAD: 'CA$', AUD: 'A$', CHF: 'CHF ',
    },

    decimals: {
      HUF: 0, JPY: 0, KWD: 3, BHD: 3,
    },

    async fetchRates() {
      const cached = localStorage.getItem(this.CACHE_KEY);
      if (cached) {
        try {
          const { ts, rates, base } = JSON.parse(cached);
          if (base === this.BASE && Date.now() - ts < this.CACHE_TTL) {
            return rates;
          }
        } catch (e) {}
      }

      try {
        const res = await fetch('https://open.er-api.com/v6/latest/' + this.BASE);
        const data = await res.json();
        if (data.result === 'success') {
          localStorage.setItem(this.CACHE_KEY, JSON.stringify({
            ts: Date.now(),
            rates: data.rates,
            base: this.BASE,
          }));
          return data.rates;
        }
      } catch (e) {}

      // Fallback: cross-calculate via USD
      try {
        const res = await fetch('https://open.er-api.com/v6/latest/USD');
        const data = await res.json();
        if (data.result === 'success') {
          const baseRate = data.rates[this.BASE];
          if (!baseRate) return null;
          const normalized = {};
          Object.keys(data.rates).forEach(function (k) {
            normalized[k] = data.rates[k] / baseRate;
          });
          normalized[this.BASE] = 1;
          localStorage.setItem(this.CACHE_KEY, JSON.stringify({
            ts: Date.now(),
            rates: normalized,
            base: this.BASE,
          }));
          return normalized;
        }
      } catch (e) {}

      return null;
    },

    format(amountInCents, currency) {
      const amount = amountInCents / 100;
      const rate = this.rates[currency];
      if (!rate) return null;
      const converted = amount * rate;
      const decimals = this.decimals[currency] !== undefined ? this.decimals[currency] : 2;
      const symbol = this.symbols[currency] || (currency + ' ');
      const formatted = converted.toLocaleString(undefined, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      });
      return symbol + formatted;
    },

    applyTo(currency) {
      document.querySelectorAll('[data-price]').forEach((el) => {
        const cents = parseInt(el.dataset.price, 10);
        if (isNaN(cents)) return;
        if (currency === this.BASE) {
          el.textContent = el.dataset.original || el.textContent;
        } else {
          if (!el.dataset.original) el.dataset.original = el.textContent;
          const converted = this.format(cents, currency);
          if (converted) el.textContent = converted;
        }
      });
    },

    FLAG_CODES: { AED: 'ae', USD: 'us', GBP: 'gb', EUR: 'eu', SAR: 'sa', QAR: 'qa', KWD: 'kw', BHD: 'bh', INR: 'in', AUD: 'au' },

    setFlagIcon(currency) {
      const icon = document.getElementById('currency-flag-icon');
      const code = this.FLAG_CODES[currency];
      if (icon && code) icon.src = 'https://flagcdn.com/20x15/' + code + '.png';
    },

    setSelectors(currency) {
      ['currency-select', 'currency-select-mobile'].forEach(function (id) {
        const sel = document.getElementById(id);
        if (!sel) return;
        sel.value = currency;
        const wrap = sel.closest('.currency-select-wrap');
        if (wrap) {
          const span = wrap.querySelector('.select-val');
          if (span) {
            const opt = sel.querySelector('option[value="' + currency + '"]');
            span.textContent = opt ? opt.textContent : currency;
          }
        }
      });
      this.setFlagIcon(currency);
    },

    async init() {
      this.rates = await this.fetchRates();
      if (!this.rates) return;

      const saved = localStorage.getItem(this.PREF_KEY) || 'USD';
      this.setSelectors(saved);
      if (saved !== this.BASE) this.applyTo(saved);

      const self = this;
      ['currency-select', 'currency-select-mobile'].forEach(function (id) {
        const sel = document.getElementById(id);
        if (!sel) return;
        sel.addEventListener('change', function () {
          const chosen = this.value;
          localStorage.setItem(self.PREF_KEY, chosen);
          self.applyTo(chosen);
          self.setFlagIcon(chosen);
          ['currency-select', 'currency-select-mobile'].forEach(function (otherId) {
            if (otherId !== id) {
              const other = document.getElementById(otherId);
              if (other) other.value = chosen;
            }
          });
        });
      });
    },
  };

  CurrencyConverter.init();

  // Public hook: re-run currency conversion over current [data-price] elements
  // (used after JS updates a price element's data-price, e.g. variant swaps).
  window.IconicRefreshPrices = function () {
    if (!CurrencyConverter.rates) return;
    var currency = localStorage.getItem(CurrencyConverter.PREF_KEY) || 'USD';
    CurrencyConverter.applyTo(currency);
  };

})();
